<figure>
  <img src="/assets/images/logo/duoges.png" alt="Duoges" />
  <figcaption>
    <span>© Duoges - Duonex - v.{{ version }} - {{ today.getFullYear() }}</span>
    <span>Todos los derechos reservados</span>
  </figcaption>
</figure>
<section class="database" *ngIf="vm.storage() as storage">
  <p class="storage">Almacenamiento ({{ storage.percentage }})</p>
  <p class="space">{{ storage.used }} / {{ storage.available }}</p>
</section>
